import initialState from "./initialState";

export const types = {
  reset: "reset",
  SET_MAP_STYLE: "SET_MAP_STYLE",
  SET_GEO_DATA: "SET_GEO_DATA",
  SET_CITIES: "SET_CITIES",
  SET_FETCHING_CITIES: "SET_FETCHING_CITIES",
  ADD_LAYER: "ADD_LAYER",
  SET_LEGEND: "SET_LEGEND",
  SET_ZOOM: "SET_ZOOM",
  SET_TILT: "SET_TILT",
  SET_POPUP_DATA: "SET_POPUP_DATA",
  SET_GRID_FILTER: "SET_GRID_FILTER",
  SET_MAP_LEGENDS: "SET_MAP_LEGENDS",
  SET_MAP_FILTER: "SET_MAP_FILTER",
  SET_POPUPS: "SET_POPUPS",
  SET_VIEW_STATE: "SET_VIEW_STATE",
  SET_ACTIVE_CITY: "SET_ACTIVE_CITY",
  SET_OVERLAYS: "SET_OVERLAYS",
  SET_CONTEXT_DATA: "SET_CONTEXT_DATA",
  SET_MEASURE_DATA: "SET_MEASURE_DATA",
  SET_SHOW_MEASURE_TOOL: "SET_SHOW_MEASURE_TOOL",
  SET_ACTIVE_GRID: "SET_ACTIVE_GRID",
  SET_ACTIVE_LOCATION: "SET_ACTIVE_LOCATION",
  SET_OPACITY: "SET_OPACITY",
};

export default {
  [types.reset]: state => {
    Object.keys(initialState()).forEach(key => {
      state[key] = initialState()[key];
    });
  },

  /**
   * Sets the mapStyle
   */
  [types.SET_MAP_STYLE]: (state, map_style) => {
    state.map_style = map_style;
  },

  /**
   * Sets the GeoData
   */
  [types.SET_GEO_DATA]: (state, data) => {
    state.geoData = data;
  },

  /**
   * Sets the list of all cities
   */
  [types.SET_CITIES]: (state, cities) => {
    state.cities = cities;
  },

  /**
   * Sets whether the cities are being fetched or not
   */
  [types.SET_FETCHING_CITIES]: (state, fetching_cities) => {
    state.fetching_cities = fetching_cities;
  },

  /**
   * Adds layers
   */
  [types.ADD_LAYER]: (state, layerData) => {
    state.layers = [layerData];
  },

  /**
   * Sets the legend values
   */
  [types.SET_LEGEND]: (state, values) => {
    state.legend = values;
  },

  /**
   * Sets the zoom levels
   */
  [types.SET_ZOOM]: (state, value) => {
    state.zoomLevel = value;
  },

  /**
   * Sets the tilt values for the map
   */
  [types.SET_TILT]: (state, value) => {
    state.isTilted = value;
  },

  /**
   * Sets the popup data
   */
  [types.SET_POPUP_DATA]: (state, data) => {
    state.popupData = data;
  },

  /**
   * Sets the legend filter values
   */
  [types.SET_GRID_FILTER]: (state, data) => {
    state.gridFilter = data;
  },

  /**
   * Sets the legends required for the map, used when there are multiple maps and legends
   */
  [types.SET_MAP_LEGENDS]: (state, data) => {
    state.mapLegends = [
      ...state.mapLegends.filter(item => item.type !== data.type),
      data,
    ];
  },

  /**
   * Sets the Legend filters for multiple maps
   */
  [types.SET_MAP_FILTER]: (state, data) => {
    state.mapFilters = [
      ...state.mapFilters.filter(item => item.type !== data.type),
      data,
    ];
  },

  /**
   * Sets the popup data, if there are multiple maps
   */
  [types.SET_POPUPS]: (state, data) => {
    state.popups = [
      ...state.popups.filter(item => item.type !== data.type),
      data,
    ];
  },

  /**
   * Sets the viewstate of the map
   */
  [types.SET_VIEW_STATE]: (state, data) => {
    state.viewState = data;
  },

  /**
   * Sets the active city
   */
  [types.SET_ACTIVE_CITY]: (state, data) => {
    state.activeCity = data;
  },

  /**
   * Sets overlay layers
   */
  [types.SET_OVERLAYS]: (state, data) => {
    state.overlays = data;
  },

  /**
   * Sets context data, right click popups
   */
  [types.SET_CONTEXT_DATA]: (state, data) => {
    state.contextData = data;
  },

  /**
   * Sets data required for the Measure tools
   */
  [types.SET_MEASURE_DATA]: (state, data) => {
    state.measureData = data;
  },

  /**
   * Flags required to toggle the measure tool
   */
  [types.SET_SHOW_MEASURE_TOOL]: (state, data) => {
    state.showMeasureTool = data;
  },

  /**
   * Sets the active selected grid
   */
  [types.SET_ACTIVE_GRID]: (state, grid_id) => {
    state.activeGrid = grid_id;
  },

  /**
   * Sets the active jump location for the map
   */
  [types.SET_ACTIVE_LOCATION]: (state, latlong) => {
    state.activeLocation = latlong;
  },

  /**
   * Sets opacity of the visualization
   */
  [types.SET_OPACITY]: (state, opacity) => {
    state.opacity = opacity;
  },
};
